import { useMemo } from "react"
import { useAppSelector } from "@/store"
import {
  useGetMatchConfirmSessionQuery,
  useGetMyMatchSessionQuery
} from "@/store/apis/matchAPI"
import { useGetPlayerProfileQuery } from "@/store/apis/playerAPI"
import { MatchSelectors } from "@/store/slices/match"

export const useMatchConfirm = () => {
  const matchSessionRedux = useAppSelector(MatchSelectors.selectMatchSession())

  const { data: playerProfile } = useGetPlayerProfileQuery()
  const { data: matchSessionQuery } = useGetMyMatchSessionQuery(
    {
      playerId: playerProfile?._id ?? ""
    },
    {
      skip: !playerProfile?._id
    }
  )
  const { data: matchConfirmSessionQuery } = useGetMatchConfirmSessionQuery(
    {
      sessionId: matchSessionRedux?.sessionId ?? "",
      playerId: playerProfile?._id ?? ""
    },
    {
      skip: !matchSessionRedux?.sessionId || !playerProfile?._id
    }
  )

  const { player, rival } = useMemo(() => {
    if (matchConfirmSessionQuery?.playerA?.playerId === playerProfile?._id) {
      return {
        player: matchConfirmSessionQuery?.playerA,
        rival: matchConfirmSessionQuery?.playerB
      }
    } else {
      return {
        player: matchConfirmSessionQuery?.playerB,
        rival: matchConfirmSessionQuery?.playerA
      }
    }
  }, [matchConfirmSessionQuery, playerProfile])

  const matchStatus = useMemo(() => {
    if (!matchSessionQuery?.status) return "WAITING_FOR_OPPONENT"

    return matchSessionQuery?.status
  }, [matchSessionQuery])

  const matchConfirmStatus = useMemo(() => {
    switch (matchStatus) {
      case "PENDING": {
        if (player?.status === "PENDING") {
          return "WAITING_FOR_YOUR_CONFIRM"
        } else if (rival?.status === "PENDING") {
          return "WAITING_FOR_OPPONENT_CONFIRM"
        } else {
          return matchStatus
        }
      }
      default: {
        return matchStatus
      }
    }
  }, [matchStatus, player, rival])

  const confirmStatus = matchConfirmSessionQuery?.reason

  return {
    player,
    rival,
    matchStatus,
    matchConfirmStatus,
    confirmStatus
  }
}
